<template>
    <div>
        <div class="row">
            <div class="col-md-12">
                <div class="panel panel-primary">
                    <div class="panel-heading">
                        <h3>Ordenar Categorias de Produto</h3>
                    </div>
                    <div class="panel-body">
                        <div class="row" v-if="!order">
                            <div class="col-md-8">
                                <div class="form-group">
                                    <label for="categoryProducts">Categorias de Produto</label>
                                    <select name="categoryProducts[]" id="categoryProducts" v-model="ordered" size="8" multiple>
                                        <option :value="index" v-for="(categoryProduct, index) in categoryProducts">
                                            {{ categoryProduct.description }}
                                        </option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-md-12 m-t-sm">
                                <button class="btn btn-primary" @click="setCategoryProducts">Ordenar Categorias de Produto <i class="fa fa-shopping-bag"></i></button>
                            </div>
                        </div>

                        <div class="row" v-if="order">
                            <div class="col-md-12">
                                <draggable v-model="selected" :list="selected" class="dragArea">
                                    <li v-for='(categoryProduct,index) in selected' :key="categoryProduct.id" class="list-group-item clearfix draggable">
                                        <i class="mdi mdi-drag pull-left" ></i>
                                        <i class="pull-left fa fa-2x fa-arrows-v align-middle"></i>
                                        <span class="pull-left stages" :id="'stage' + categoryProduct.id">{{ index + 1 }}. {{ categoryProduct.description }} </span>
                                        <button class="btn btn-danger pull-right" @click="remove(categoryProduct, index)">
                                            <i class="fa fa-trash"></i>
                                        </button>
                                    </li>
                                </draggable>
                            </div>
                            <div class="col-md-12 m-t-md">
                                <button class="btn btn-info" @click="back"><i class="fa fa-arrow-left"></i> Voltar</button>
                                <button class="btn btn-success" @click="save" style="margin-left:3px;">Salvar Ordenação <i class="fa fa-save"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import draggable from 'vuedraggable';
    import { postReorder } from "../../utils";

    export default{
        data: function(){
            return {
                categoryProducts: [],
                selected: [],
                ordered: [],
                order: false
            }
        },
        components: {
            draggable
        },
        methods: {
            getCategoryProductsArray: function(data){
                let array = [];
                $.each(data, function(index, value){
                    if(value.sort_by){
                        array.push(index);
                    }
                });
                return array;
            },
            getCategoryProducts: function(){
                let self = this;
                let api  = self.$store.state.api + 'categoryProduct?paginated=false';
                let categoryProducts = $('#categoryProducts');

                self.$http.get(api)
                    .then((response) => {
                        self.categoryProducts = response.data.data;
                        self.ordered  = self.getCategoryProductsArray(self.categoryProducts);
                    })
                    .then(() => {
                        categoryProducts.bootstrapDualListbox();
                        categoryProducts.ready(function () {
                            categoryProducts.bootstrapDualListbox('refresh', true);
                        });
                    })
                    .catch((error) => {
                        self.$message(null, 'Ocorreu um erro ao buscar os Categorias de Produto', 'error');
                    });
            },
            setCategoryProducts: function(){
                const self   = this;
                let categoryProducts = self.selected;

                $('#categoryProducts').find(':selected').each(function(){
                    categoryProducts.push(self.categoryProducts[$(this).val()]);
                });

                self.selected = categoryProducts;
                self.order = true;
            },
            save: function(){
                const self = this;

                postReorder(self, self.selected, "sort/categoryProduct", self.getCategoryProductsArray);
            },
            remove: function(categoryProduct, index){
                const self = this;
                const api  = self.$store.state.api + 'categoryProduct/' + categoryProduct.id;

                let array  = [];
                $.each(self.selected, function(key, value){
                    if(index !== key){
                        array.push(value);
                    }
                });

                self.$http.put(api, {
                    sort_by: null
                })
                    .then((response) => {
                        this.selected = array;
                    });
            },
            back: function(){
                window.location.reload();
            }
        },
        mounted: function(){
            this.getCategoryProducts();
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CategoryProductOrder/Index.vue